/**
 * 订单详情菜品列表 React key（与 Mobile `order-detail-dish-list` 语义一致）。
 */

/** 含订单明细 id 的最小菜品行结构 */
export type OrderDetailDishRowLike = {
    /** 订单明细 id，同 id 可能多行，key 须配合 index */
    order_detail_id?: number | null;
};

/**
 * 生成订单详情菜品列表项 React key；同表内 `order_detail_id` 可能重复，须带上 index。
 * @param item - 菜品行
 * @param index - 当前列表下标
 * @param prefix - key 前缀
 */
export function getOrderDetailDishRowKey(
    item: OrderDetailDishRowLike,
    index: number,
    prefix: string
): string {
    const idPart = item.order_detail_id != null ? String(item.order_detail_id) : 'noid';
    return `${prefix}-${index}-${idPart}`;
}
